import React, { useState, useEffect } from "react";
import { Transition } from "@headlessui/react";

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const [currentLink, setCurrentLink] = useState("Home");
    const burgerLine = `h-1 w-8 my-1 rounded-full bg-night transition ease transform duration-300`;
    const [hasShadow, setHasShadow] = useState(false);

    const handleScroll = () => {
        // Define a regular expression pattern to match URLs like "/services/[other-route]"
        const servicesPattern = /^\/services\//;

        // Get the current URL
        const currentURL = window.location.pathname;

        // If the current URL matches the servicesPattern, select the Services link
        if (servicesPattern.test(currentURL)) {
            setCurrentLink("Services");
            return;
        }

        const scrollY = window.scrollY;
        const navbarHeight = document.getElementById("navbar").offsetHeight;
        const aboutSection = document.getElementById("about").offsetTop;
        const servicesSection = document.getElementById("services").offsetTop;

        if (scrollY < aboutSection) {
            setCurrentLink("Home");
        } else if (scrollY >= aboutSection && scrollY < servicesSection) {
            setCurrentLink("About");
        } else if (scrollY >= servicesSection) {
            setCurrentLink("Services");
        }

        setHasShadow(scrollY > navbarHeight);
    };


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const links = [
        { text: "Home", url: "/#" },
        { text: "About", url: "/#about" },
        { text: "Services", url: "/#services" },
    ];

    return (
        <nav className={`navbar py-3 z-50 fixed w-full bg-white ${hasShadow ? 'shadow-lg' : ''}  lg:px-10 ${isOpen ? 'rounded-b-xl shadow-lg' : ''}`} id="navbar">
            <div className="flex items-center justify-around lg:px-70 px-5 ">
                <div className="md:flex items-center space-x-4">
                    <div className="text-night font-bold md:text-4xl text-2xl font-title text-center">
                        <div className="flex items-center">
                            <img src="/logo.png" alt="Maximum Contracting Logo" className="w-20 h-20 mr-4" />
                            <h1 className="drop-shadow-lg mb-0 pb-0">Maximum Contracting</h1>
                        </div>
                    </div>
                </div>
                <div className="md:flex items-center space-x-4">
                    {links.map((link, index) => (
                        <a
                            key={index}
                            href={link.url}
                            className={`hidden lg:block text-night duration-100 transition-all hover:bg-navy-blue hover:text-white hover:shadow-md focus:bg-n navy-blue focus:text-white focus:shadow-lg hover:rounded-lg py-2 px-3 text-lg ${currentLink === link.text ? 'bg-navy-blue text-white rounded-lg shadow-lg' : ''}`}
                            onClick={() => setCurrentLink(link.text)}
                        >
                            {link.text}
                        </a>
                    ))}


                    <span className="hidden lg:block">|</span>

                    <a href="/#contact" className="hidden lg:block bg-rose-600 text-white rounded-lg shadow-lg py-2 px-3 text-lg  hover:text-white hover:shadow-md hover:scale-105 focus:text-white transition-all duration-200">
                        Contact Us
                    </a>
                </div>

                <div className={`lg:hidden flex items-center transition-all ease-in-out duration-300`}>
                    <button onClick={toggleMenu} className="text-night flex flex-col h-12 w-12 justify-center items-center group" name="Menu Button" aria-label="Menu Button">
                        <div
                            className={`${burgerLine} ${isOpen
                                ? "rotate-45 translate-y-3 opacity-100 "
                                : "opacity-100 "
                                }`}
                        />
                        <div className={`${burgerLine} ${isOpen ? "opacity-0" : "opacity-100 "}`} />
                        <div
                            className={`${burgerLine} ${isOpen
                                ? "-rotate-45 -translate-y-3 opacity-100 "
                                : "opacity-100 "
                                }`}
                        />
                    </button>
                </div>
            </div>
            <Transition
                show={isOpen}
                enter="transition-opacity duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className={`lg:hidden flex flex-col mt-4 space-y-4`}>
                    {links.map((link, index) => (
                        <a
                            key={index}
                            href={link.url}
                            className={`text-night duration-100 transition-all hover:bg-navy-blue hover:text-white hover:shadow-md focus:bg-navy-blue focus:text-white focus:shadow-md hover:rounded-lg p-3 m-3 text-xl ${currentLink === link.text ? 'bg-navy-blue text-white rounded-lg shadow-lg' : ''}`}
                            onClick={() => setCurrentLink(link.text)}
                        >
                            {link.text}
                        </a>

                    ))}
                    <a href="/#contact" className=" bg-rose-600 text-white rounded-lg shadow-lg py-2 px-3 text-lg  hover:text-white hover:shadow-md m-3 focus:text-white transition-all duration-200">
                        Get in Touch
                    </a>
                </div>
            </Transition>
        </nav>
    );
}

export default Navbar;
